import React from 'react';
import style from '../style.scss';
import { Button } from 'components/common/Button';
import { Download } from 'components/common/Icon';
import { Spinner } from 'components/common/Spinner';
import Card from '../Card';
import App from 'common/backbone-app';
import { useReportList, DAC7ReportList } from './useReportList';
import { downloadFile } from './downloadFile';

const getDescriptionText = (reports: DAC7ReportList) => {
  const LANG = Wahanda.lang.reports.dac7;

  if (reports.values.length) {
    if (reports.values.length > 1) {
      return Wahanda.Template.render(LANG.multipleReports, {
        years: reports.values.sort((a, b) => Number(a) - Number(b)).join(', '),
      });
    }

    return Wahanda.Template.render(LANG.singleReport, {
      year: reports.values[0],
    });
  }

  return LANG.noReports;
};

// DAC7 is the EU directive name. In the UK, the equivalent regulation is called
// DRR (Digital Reporting Rules). Both fall under the OECD Digital Platform
// Information (DPI) framework. If searching for DRR, this is the right place.
export const DAC7Report = () => {
  const cardTitle = App.config.get('venue').countryCode === 'GB' ? 'DRR' : 'DAC 7';
  const { reports, isLoading } = useReportList();

  const handleDownload = (year: string) => () => {
    downloadFile(year);
  };

  if (!reports || isLoading) {
    return (
      <Card className={style.card}>
        <div className={style.cardHead}>{cardTitle}</div>
        <div className={style.loading}>
          <Spinner dark />
        </div>
      </Card>
    );
  }

  return (
    <Card className={style.card}>
      <div className={style.cardHead}>{cardTitle}</div>
      <div className={style.explanation}>{getDescriptionText(reports)}</div>

      {reports.values.length === 1 && (
        <div>
          <Button
            label="Download"
            variant="hollow"
            colour="help"
            onClick={handleDownload(reports.values[0])}
            dataTest="download-button"
          />
        </div>
      )}

      {reports.values.length > 1 && (
        <div className={style.box}>
          {reports.values.map((year) => (
            <div
              key={year}
              className={style.link}
              data-test-id="download-link"
              onClick={handleDownload(year)}
            >
              <div className={style.reportDownload}>
                {year}
                <Button variant="hollow" colour="help" icon={<Download size="small" />} />
              </div>
            </div>
          ))}
        </div>
      )}
    </Card>
  );
};
